<<template>
  <div>
    <m-tab :tabs="tabs" :active-tab.sync="activeTab" />
  </div>
</template>

  <script>
  import MTab from '@/components/m-tab/MTab.vue';
  const MoadianConfig = () => import( /* wepackChunkName: "distribution" */ "@/modules/moadian/MoadianConfig")
  const MoadianFactorsList = () => import( /* wepackChunkName: "distribution" */ "@/modules/moadian/MoadianFactorsList")
  const MoadianSubmitFactors = () => import( /* wepackChunkName: "distribution" */ "@/modules/moadian/MoadianSubmitFactors")

  export default {
    components: {
      MTab
    },
    data() {
      return {
        activeTab: 0,
      };
    },
    computed: {
      tabs() {
        return [
          {
            title: "اتصال به مودیان",
            component: MoadianConfig,
            route: "/panel/moadian/config",
            perm: "keysan_company",
          },
          {
            title: "ثبت فاکتور",
            component: MoadianSubmitFactors,
            route: "/panel/moadian/submit",
            perm:"keysan_factor",
          },
          {
            title: "لیست فاکتور های ثبت شده",
            component: MoadianFactorsList,
            route: "/panel/moadian/factors",
            perm:"keysan_factor",
          },
        ];
      }
    }
  };
</script>